import axios from "axios";
import { Cookies, useCookies } from "react-cookie";

type QueryType = {
  quarter1: any;
  year1: any;
  class_type?: any;
  limits?: any;
};

class ReportApi {
  url: string;
  source = axios.CancelToken.source();


 constructor() {
  //  this.url = "http://127.0.0.1:8000"
this.url = "https://mbi2025.zainrohn.com/api/public"; 

// this.url = "https://idb.zainrohn.com/api/public";  

    //add line
// this.url = "https://ifrs.zainrohn.com/public"; 
   
    const [cookies, _, removeCookie] = useCookies();

    // Add Auth header
    axios.interceptors.request.use((config) => {
      config.headers['Accept'] = 'application/json';
      config.headers['Content-Type'] = 'application/json';
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.cancelToken = this.source.token;
      if (cookies.userinfo) {
        config.headers['Authorization'] = cookies.userinfo.accessToken;
      }
      return config;
    });

     // Handle 401
        axios.interceptors.response.use((response) => {
            if (!response)
                return Promise.reject(response)
            return response
        }, function (error) {
            if (!error)
                return Promise.reject(error);
            if (401 === error.response?.status) {
                removeCookie("userinfo")
                removeCookie("token")
            } else {
                return Promise.reject(error);
            }
        });



  }
  // دالة إرسال التقرير
  report() {
    return {
      generate: (query: QueryType, endpoint = "reports/cif") => {
        console.log("Sending request with query:", query);
        return axios.post(`${this.url}/${endpoint}`, query);
      },
    };
  }

  // لإلغاء أي طلبات جارية
  abortCalls = () =>
    this.source.cancel("Operation canceled due to route change.");
}

export default ReportApi;
